import { createSelectors as s } from "@waitroom/state";
import { create as a } from "zustand";
const t = () => ({
  offTheRecordStatus: "DISABLED",
  recordingStatus: ""
}), S = a()(t), e = s(S), n = (o) => {
  e.setState((r) => ({ ...r, ...o }));
}, i = () => e.setState(t());
export {
  i as resetRoomState,
  n as updateRoomState,
  e as useRoomStore
};
